module.exports = __webpack_public_path__ + "static/media/object_immotal6.ce65e173.png";